export default __webpack_public_path__ + "static/media/Yoru_artwork.2eb4dff3.png";